import { styled as l, Box as O, CircularProgress as U } from "@mui/material";
import _ from "../hooks/useGetAccountInvitees.js";
import D from "../../temp-lib/components/share/apeiron/ApeironEllipsisTypography.js";
import E from "../../temp-lib/components/share/next/NextLink.js";
import L from "../../temp-lib/components/share/popup/InfoPopup.js";
import { INFO_POPUP_TYPE as R } from "../../temp-lib/constants/popup.js";
import { useAccountContext as S } from "../../temp-lib/contexts/account/AccountContext.js";
import { useConfigContext as W } from "../../temp-lib/contexts/config/ConfigContext.js";
import z from "../../ui-lib/components/ApeironSimpleButton.js";
import F from "../../wallet-lib/hooks/useWalletAddress.js";
import { format as G } from "date-fns";
import M from "query-string";
import * as d from "ramda";
import { lazy as q, useState as H, useCallback as A, useMemo as K, Suspense as Y } from "react";
import { useTranslation as $, Trans as J } from "react-i18next";
import { jsx as t, Fragment as C, jsxs as Q } from "react/jsx-runtime";
const V = l(z)`
  border-radius: 100px;
  border: 1px solid white;
  font-size: 14px;
  font-weight: 300;
  padding: 1px 18px;
  :hover {
    background-color: unset;
  }
  :disabled {
    background-color: unset;
    color: white;
    opacity: 0.2;
  }
  :focus {
    background-color: unset;
  }
  strong {
    font-size: 16px;
    font-weight: 600;
    margin-right: 4px;
  }
  ${(i) => i.theme.breakpoints.up("res1024")} {
    min-width: unset;
  }
`, X = l(q(() => import("../../temp-lib/components/share/apeiron/ApeironPagingDataGrid.js")))`
  padding: 1%;
  margin: auto;
  width: 95%;
  .Custom-Grid {
    .ag-row {
      border-bottom: 1px solid #232326;
    }
    .ag-header-row {
      background-color: #151615;
    }
  }
`, Z = l(E)`
  text-decoration: underline;
`, c = l(D)`
  width: 100%;
  display: flex;
  justify-content: center;
`, ee = l(L)`
  height: 90%;
  max-height: 580px;
  max-width: 900px;
  width: 100%;
  .Custom-Content {
    height: 100%;
    overflow-y: auto;
  }
`, ge = (i) => {
  var p, f;
  const {
    t: a
  } = $(), {
    account: n,
    className: v,
    loading: k
  } = i, {
    config: s
  } = W(), {
    account: N
  } = S(), {
    compareAddress: B
  } = F(), m = B(n == null ? void 0 : n.walletAddress, N.walletAddress), [P, T] = H(!1), u = A(() => {
    T((e) => !e);
  }, []), {
    fetch: h
  } = _(), j = K(() => [{
    cellClass: "custom-ag-cell-center",
    field: "start",
    headerClass: "custom-ag-header-center",
    headerName: "",
    pinned: "left",
    sortable: !1,
    width: 10
  }, {
    cellClass: "custom-ag-cell-center",
    field: "name",
    headerClass: "custom-ag-header-center",
    headerName: a("common.grid.name"),
    minWidth: 250,
    sortable: !1,
    cellRenderer: (e) => {
      var r;
      return /* @__PURE__ */ t(c, {
        children: (r = e.data) == null ? void 0 : r.name
      });
    }
  }, {
    cellClass: "custom-ag-cell-center",
    field: "walletAddress",
    flex: 1,
    headerClass: "custom-ag-header-center",
    headerName: a("common.grid.address"),
    minWidth: 300,
    sortable: !1,
    cellRenderer: (e) => {
      var g, w, x, y, b;
      if (d.isNil((g = e.data) == null ? void 0 : g.walletAddress)) return /* @__PURE__ */ t(C, {
        children: " - "
      });
      const r = ((w = s == null ? void 0 : s.adeptus) == null ? void 0 : w.inventoryUrl) || "", o = d.isNotEmpty(r) ? M.stringifyUrl({
        url: r,
        query: {
          ownerWalletAddresses: (x = e.data) == null ? void 0 : x.walletAddress
        }
      }) : "";
      return /* @__PURE__ */ t(c, {
        children: d.isNotEmpty(o) ? /* @__PURE__ */ t(Z, {
          href: o,
          target: "_blank",
          children: (y = e.data) == null ? void 0 : y.walletAddress
        }) : (b = e.data) == null ? void 0 : b.walletAddress
      });
    }
  }, {
    cellClass: "custom-ag-cell-center",
    field: "createdAt",
    headerClass: "custom-ag-header-center",
    headerName: a("believer.join_date"),
    width: 250,
    sortable: !1,
    cellRenderer: (e) => {
      var o;
      const r = (o = e.data) == null ? void 0 : o.createdAt;
      return /* @__PURE__ */ t(c, {
        children: r ? G(new Date(r), "yyyy-MM-dd") : ""
      });
    }
  }], [(p = s == null ? void 0 : s.adeptus) == null ? void 0 : p.inventoryUrl, a]), I = A(async (e, r) => {
    const o = await h({
      isInvitee: !0,
      pageSize: r,
      page: e
    });
    return {
      data: o.data,
      total: o.pageInfo.total
    };
  }, [h]);
  return /* @__PURE__ */ Q(C, {
    children: [/* @__PURE__ */ t(V, {
      className: v,
      disabled: k || !m,
      onClick: u,
      children: /* @__PURE__ */ t(J, {
        children: a("account_header.believer", {
          count: ((f = n == null ? void 0 : n.invitation) == null ? void 0 : f.believerCount) || 0
        })
      })
    }), m && /* @__PURE__ */ t(ee, {
      open: P,
      type: R.BLACK,
      onClose: u,
      children: /* @__PURE__ */ t(Y, {
        fallback: /* @__PURE__ */ t(O, {
          sx: {
            display: "flex",
            justifyContent: "center",
            p: 4
          },
          children: /* @__PURE__ */ t(U, {})
        }),
        children: /* @__PURE__ */ t(X, {
          columnDefs: j,
          fetch: I,
          rowHeight: 40
        })
      })
    })]
  });
};
export {
  ge as default
};
//# sourceMappingURL=AdeptusBelieverButton.js.map
